import api from './api';

const rotanaService = {
    // The connectors and their routes, from the legacy DB. Fast, and everything on the screen depends
    // on it, so nothing slow is allowed to share the call.
    listConnectors: async () => {
        const res = await api.get('/rotana/connectors');
        return res.data;
    },
    // THE MESSAGE PIPES: the lambdas that have actually written to this chain's message log.
    //
    // A SEPARATE CALL BECAUSE IT IS SLOW. `messagelog` is partitioned by connector_id alone, so
    // grouping by lambda across the chain reads the whole log — seconds, growing. It used to ride along
    // on listConnectors behind a flag, which meant the connector picker could not open until Athena
    // finished a scan the user had not asked for. Callers fire this without awaiting it and fill the
    // section in when it lands.
    listGateways: async () => {
        const res = await api.get('/rotana/gateways');
        return res.data;
    },
    // connectorIds (optional) widens the query to a whole route. Records are filed under the connector
    // that RECEIVED each message, so one channel's traffic is split across its two connectors — passing
    // both returns the full conversation instead of one direction of it.
    getLogs: async (connectorId, filters = {}) => {
        const params = new URLSearchParams();
        if (filters.direction)     params.set('direction',     filters.direction);
        if (filters.messageType)   params.set('messageType',   filters.messageType);
        if (filters.payloadSearch) params.set('payloadSearch', filters.payloadSearch);
        if (filters.transactionId) params.set('transactionId', filters.transactionId);
        // Selecting a pipe rather than a connector: every record that lambda wrote, across the chain.
        if (filters.lambda)        params.set('lambda',        filters.lambda);
        if (filters.connectorIds?.length > 1) params.set('connectorIds', filters.connectorIds.join(','));
        // Following ONE message through the pipeline. `hcTransactionId` is the id the connectors pass
        // hop to hop; `allConnectors` drops the connector predicate so the answer spans the whole chain
        // rather than the screen you happen to be on. The API refuses allConnectors without an id, so
        // the two always travel together.
        if (filters.hcTransactionId) {
            params.set('hcTransactionId', filters.hcTransactionId);
            params.set('allConnectors', 'true');
        }
        const qs = params.toString() ? '?' + params.toString() : '';
        const res = await api.get(`/rotana/connectors/${connectorId}/logs${qs}`);
        return res.data;
    },
    // Payloads for one transaction, fetched when a log row is expanded. The list deliberately omits them —
    // 500 base64 SOAP envelopes in one response exceeded Lambda's 6MB limit and came back as a 502.
    getLogPayloads: async (connectorId, transactionId, connectorIds) => {
        const qs = connectorIds?.length > 1 ? `?connectorIds=${connectorIds.join(',')}` : '';
        const res = await api.get(`/rotana/connectors/${connectorId}/logs/${encodeURIComponent(transactionId)}/payloads${qs}`);
        return res.data;
    },
    // Raise a Jira ticket for a whole transaction (superadmin). The SERVER assembles the context: it
    // re-reads every hop and payload for the transaction across the connector group, so the ticket holds
    // the child records whether or not the user expanded them on screen.
    createJiraTicket: async (connectorId, transactionId, { note, pageUrl, connectorIds } = {}) => {
        const qs = connectorIds?.length > 1 ? `?connectorIds=${connectorIds.join(',')}` : '';
        const res = await api.post(
            `/rotana/connectors/${connectorId}/logs/${encodeURIComponent(transactionId)}/jira${qs}`,
            { note, pageUrl });
        return res.data;
    },
    purgeLogs: async (connectorId) => {
        const res = await api.delete(`/rotana/connectors/${connectorId}/logs`);
        return res.data;
    },
};

export default rotanaService;
